import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/setting/brand/`;

const getBrands = async (params = {}) => {
    return await axios.get(API_URL, { params });
};

const getBrandByName = async (name) => {
    return await axios.get(API_URL + 'search', { params: { name } });
};

const addBrand = async (brandData) => {
    return await axios.post(API_URL, brandData);
};

const editBrand = async (brandId, updatedData) => {
    return await axios.put(API_URL + brandId, updatedData);
};

const deleteBrand = async (brandId) => {
    return await axios.delete(API_URL + brandId);
};

export default {
    getBrands,
    getBrandByName,
    addBrand,
    editBrand,
    deleteBrand,
};
